<template>
  <div class="flex flex-col gap-10 relative">
    <!-- Favorites section skeleton -->
    <ContentRowSkeleton :count="8" />
  </div>
</template>

<script setup>
import ContentRowSkeleton from './ContentRowSkeleton.vue';
</script>
